import { PaginatorData } from 'polly-qubit';
import { OmixAtlasTableColumns, TableSettingInterface } from '../../../../@core/interfaces';
import { buyDataPayload } from '../../constants/omixatlas.constants';
import { BuyDatasetPayload, CopyDatasetPayload } from '../interfaces/explorer.interface';

/**
 * @description function creates payload for copying dataset from omixatlas to workspaces
 * @param repoId  current repo id
 * @param datasetId selected dataset id
 * @param workspaceId selected workspace id
 * @param workspacePath selected folder path inside a workspace
 * @returns return created payload
 */
export function createCopyPayload(repoId: string, datasetId: string, workspaceId: number, workspacePath: string): CopyDatasetPayload {
  return {
    data: {
      type: 'workspaces',
      attributes: {
        dataset_id: datasetId,
        repo_id: repoId,
        workspace_id: String(workspaceId),
        workspace_path: workspacePath,
      },
    },
  };
}

export function getOmixAtlasTableColumns(columnOption: TableSettingInterface): OmixAtlasTableColumns {
  const { checked, pinned, position, ...columns } = columnOption;
  return { pinned, ...columns };
}

export function createBuyPayload(
  sourceRepoId: string,
  destinationRepoId: string,
  datasetsUriArray: string[],
  atlasDataType: string
): BuyDatasetPayload {
  const payload: BuyDatasetPayload = buyDataPayload;
  payload.data.attributes = {
    ...payload.data.attributes,
    source_repo_id: sourceRepoId,
    destination_repo_id: destinationRepoId,
    datasets: datasetsUriArray,
    flags: {
      ...payload.data.attributes.flags,
      row_metadata: atlasDataType !== 'bulk_rna_seq' ? 'true' : 'false',
    }
  };
  return payload;
}

export function paginatorInitialData(rows: number): PaginatorData {
  return ({
    first: 0,
    page: 1,
    pageCount: 0,
    rows
  });
}
